'use client';

import { useEffect } from 'react';
import { initRum } from './rum-init';

export default function RumClient() {
  useEffect(() => {
    initRum(); // idempotent inside rum-init
  }, []);

  return null;
}
